import React from "react";
import { BASE_TRACKER_URL } from "../../utils/constants";

interface StepCheckProps {
  checked: boolean;
  text: string;
}

const StepCheck: React.FC<StepCheckProps> = ({ checked, text }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 16,
        justifyContent: "flex-start",
        width: "100%",
        paddingLeft: 16,
      }}
    >
      <div
        style={{
          width: 24,
          height: 24,
          border: `2px solid ${
            checked ? "var(--color-success)" : "var(--color-secondary)"
          }`,
          borderRadius: "50%",
          background: `${checked ? "var(--color-success)" : "transparent"}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {checked && (
          <img
            src={`${BASE_TRACKER_URL}/checkmark.svg`}
            alt="checkmark"
            style={{ width: 12, height: 12, display: "block" }}
          />
        )}
      </div>
      <span
        style={{
          color: checked ? "var(--color-success)" : "var(--color-primary)",
          fontSize: "0.75rem",
          fontWeight: 500,
          textAlign: "left",
          width: "100%",
          display: "block",
        }}
      >
        {text}
      </span>
    </div>
  );
};

export default StepCheck;
